// extracted by mini-css-extract-plugin
export default {"mediumMobile":"(max-width: 480px)","playIconWrapper":"PlayIcon_playIconWrapper__jpzzW","playIcon":"PlayIcon_playIcon__49qMC"};